export interface UpcomingMessage<T = any> {
  data: T;
  sender: Window;
}
